<div class="container" style="padding-top: 1%">
  <h2>Procesare Comandă</h2>
</div>
<div class="container" style="padding-top: 2%">
  <div class="form-group row">
    <label for="code" class="col-sm-2 col-form-label">Cod</label>
    <div class="input-group col-sm-10">
      <input type="text" class="form-control" id="code" [(ngModel)]="code" (keyup.enter)="processCode()" [readonly]="isProcessing" placeholder="4CE0460D0G">
      <div>
        <button class="btn btn-outline-success" (click)="processCode()"><i class="fas fa-check"></i></button>
      </div>
    </div>

  </div>



  <div class="form-group row">
    <label for="currentNetWeight" class="col-sm-2 col-form-label">Greutate Netă(KG)</label>
    <div class="col-sm-2">
      <input type="number" name="currentNetWeight" [(ngModel)]="currentNetWeight" class="form-control" id="currentNetWeight">
    </div>

    <label for="currentGrossWeight" class="col-sm-2 col-form-label">Greutate Brută(KG)</label>
    <div class="col-sm-2">
      <input type="number" name="currentGrossWeight" [(ngModel)]="currentGrossWeight" class="form-control" id="currentGrossWeight">
    </div>
  </div>

  <div class="form-group" >
    <mat-radio-group [(ngModel)]="codeType" disabled="{{isProcessing}}">
      <mat-radio-button style="padding: 1%" value="SN">Serial Number</mat-radio-button>
      <mat-radio-button style="padding: 1%" value="MAC">MAC</mat-radio-button>
    </mat-radio-group>
  </div>

</div>
<div class="container" style="padding-top: 1%">
  <h2>Linii Comandă</h2>
</div>
<div class="container" style="padding-top: 2%">
  <table class="table table-responsive">
    <thead>
    <tr>
      <th style="width: 5%"></th>
      <th style="width: 5%"></th>
      <th style="width: 20%">PartNo</th>
      <th style="width: 20%">Piesă</th>
      <th style="width: 12%;text-align: center">Cantitate</th>
      <th style="width: 12%;text-align: center">Cantitate Scanată(SN/MAC)</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
      <tr *ngFor="let key of getLinePage()">
        <td>
          <button type="button" class="btn"><i class="fas fa-arrow-right" [ngClass]="{'invisible': currentSelectedLine != key}"></i></button>
        </td>
        <td>
            <button type="button" (click)=selectLine(key) class="btn btn-outline-info"><i class="bi bi-stop-circle"></i></button>
        </td>
        <td>
          {{key.split('\t')[0]}}
        </td>
        <td>
          {{key.split('\t')[1]}}
        </td>
        <td style="text-align: center">
          {{lines.get(key)}}
        </td>
        <td style="text-align: center">
          {{currentScannedCodes.get(key).sn.length}} / {{currentScannedCodes.get(key).mac.length}}
        </td>
        <td>
          <button type="button" class="btn btn-outline-secondary" style="margin: 1%" title="Modificare" (click)="editLineScans(modalLinesScans, key)"><i class="far fa-edit"></i></button>
        </td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="numberOfLinePages > 1" class="container">
    <div class="container-fluid col-12">
      <div class="row">
        <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToPrevPage()"><i class="bi bi-chevron-left"></i></button>
        <div style="margin: 4px; font-size: 19px">{{currentLinePage}} / {{numberOfLinePages}}</div>
        <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToNextPage()"><i class="bi bi-chevron-right"></i></button>
      </div>
    </div>
  </div>
  <div class="row" style="padding-top: 1%">
    <button
      type="button" class="btn btn-success" (click)="closeProcessing()" style="margin: 1%"><i class="far fa-save"></i> Salvare</button>
    <button
      type="button" class="btn btn-primary" (click)="finalizeOrder()" style="margin: 1%"><i class="fa fa-flag-checkered"></i> Finalizare</button>
  </div>
</div>


<ng-template #modalLinesScans let-modalLinesScans>
  <div class="modal-header">
    <h4 class="modal-title">Modificare scanări {{currentModifiableLine}}</h4>
  </div>
  <div class="modal-body">
    <ngb-accordion [closeOthers]="true">
      <ngb-panel id="sn">
        <ng-template ngbPanelTitle>
          <span>Serial number</span>
        </ng-template>
        <ng-template ngbPanelContent>
          <table class="table-responsive">
            <thead>
            <tr>
              <th  scope="col" style="width: 35%; font-size: small">
                Serial Number
              </th>
              <th  scope="col" style="width: 15%; font-size: small">
                Greutate Netă(KG)
              </th>
              <th  scope="col" style="width: 15%; font-size: small">
                Greutate Brută(KG)
              </th>
              <th  scope="col" style="width: 15%">

              </th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let sn of getSNPage()">
              <th style="font-weight:normal;">
                {{sn.Item1}}
              </th>
              <th style="font-weight:normal;text-align: center">
                <button class="btn btn-light" style="height: 100%; width:100%" (click)="changeSNWeightNet(sn)">
                  {{sn.Item2}}
                </button>

              </th>
              <th style="font-weight:normal;text-align: center">
                <button class="btn btn-light" style="height: 100%; width:100%" (click)="changeSNWeightGross(sn)">
                  {{sn.Item3}}
                </button>
              </th>
              <th style="">
                <button
                  type="button" class="btn btn-outline-danger" (click)="deleteSN(sn.Item1)" style="margin: 1%">Șterge <i class="bi bi-trash"></i>
                </button>
              </th>
            </tr>
            </tbody>
          </table>
          <div *ngIf="numberOfOrderPagesSN > 1" class="row">
            <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToPrevPageSN()"><i class="bi bi-chevron-left"></i></button>
            <div style="margin: 4px; font-size: 19px">{{currentOrderPageSN}} / {{numberOfOrderPagesSN}}</div>
            <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToNextPageSN()"><i class="bi bi-chevron-right"></i></button>
          </div>
        </ng-template>
      </ngb-panel>
      <ngb-panel id="mac">
        <ng-template ngbPanelTitle>
          <span>MAC</span>
        </ng-template>
        <ng-template ngbPanelContent>


          <table class="table-responsive">
            <thead>
            <tr>
              <th  scope="col" style="width: 35%; font-size: small">
                Serial Number
              </th>
              <th  scope="col" style="width: 15%; font-size: small">
                Greutate Netă(KG)
              </th>
              <th  scope="col" style="width: 15%; font-size: small">
                Greutate Brută(KG)
              </th>
              <th  scope="col" style="width: 15%">

              </th>
            </tr>
            </thead>
            <tbody>

            <tbody>
            <tr *ngFor="let mac of getMACPage()">
              <th style="font-weight:normal;">
                {{mac.Item1}}
              </th>
              <th style="font-weight:normal;text-align: center">
                <button class="btn btn-light" style="height: 100%; width:100%" (click)="changeMACWeightNet(mac)">
                  {{mac.Item2}}
                </button>
              </th>
              <th style="font-weight:normal;text-align: center">
                <button class="btn btn-light" style="height: 100%; width:100%" (click)="changeMACWeightGross(mac)">
                  {{mac.Item3}}
                </button>
              </th>
              <th style="">
                <button
                  type="button" class="btn btn-outline-danger" (click)="deleteMAC(mac.Item1)" style="margin: 1%">Șterge <i class="bi bi-trash"></i>
                </button>
              </th>
            </tr>
            </tbody>
          </table>
          <div *ngIf="numberOfOrderPagesMAC > 1" class="row">
            <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToPrevPageMAC()"><i class="bi bi-chevron-left"></i></button>
            <div style="margin: 4px; font-size: 19px">{{currentOrderPageMAC}} / {{numberOfOrderPagesMAC}}</div>
            <button class="btn btn-info" style="margin: 2px" type="button" (click)="goToNextPageMAC()"><i class="bi bi-chevron-right"></i></button>
          </div>


        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="applyLinesDetailsModifications(modalLinesScans)"><i class="bi bi-check-lg"></i> Aplicare</button>
  </div>
</ng-template>
